export default "__VITE_ASSET__DHn$CE0c__"